// @flow

import _ from 'lodash';
import ko from 'rgs-knockout';

import type {
	Accessor,
	Observable,
	Computed,
} from 'rgs-knockout';


export type CssBindingValue = { [string]: Accessor<boolean> };

export type TemplateBindingValue = {
	html: string,
	data: any,
};

export type StepId = any;

export type StepOptions = {
	id: StepId,

	name: string | Observable<string>,

	skip?: Accessor<boolean>,

	css?: CssBindingValue,

	icon?: string, // one of fontawesome icons, without 'fa-' prefix, e.g. 'check'
	iconCss?: CssBindingValue,

	body: {
		template: TemplateBindingValue,
	},

	summary: {
		template: TemplateBindingValue,
	},

	gtmProcessing?: {
		editBtnEvent?: string,
		editBodyEvent?: string,
	},
};

type ClosedState = 'summary' | 'hidden';

export class Step {
	id: StepId;

	_options: StepOptions;

	Edited: Observable<boolean>;
	Locked: Observable<boolean>;
	Skip: Computed<boolean>;

	_ClosedState: Computed<ClosedState>;

	constructor (options: StepOptions) {
		this._options = _.defaultsDeep(options, {
			icon: undefined,
			iconCss: {},
			overlay: false,
			scroll: true,
			isAnimated: true,
			gtmProcessing: {
				editBtnEvent: undefined,
				editBodyEvent: undefined,
			},
		});

		const { id, isAnimated, overlay, scroll } = this._options;

		this.id = id;

		this.IsAnimated = isAnimated;
		this.Overlay = overlay;
		this.Scroll = scroll;
		this.Edited = ko.observable(false);
		this.Locked = ko.observable(false);
		this.Skip = ko.pureComputed(() => Boolean(_.result(options, 'skip')));
		this._ClosedState = ko.pureComputed(() => this.Edited() ? 'summary' : 'hidden');
	}

	isNull () {
		return false;
	}
}

export const nullStep = new (class NullStep extends Step {
	constructor () {
		super({
			id: undefined,
			name: '',
			body: { template: { html: '', data: null } },
			summary: { template: { html: '', data: null } },
		});

		this.Edited = ko.pureComputed({
			read: _.constant(false),
			write: _.noop,
		});
	}

	isNull () {
		return true;
	}
});
